import React from "react";
import { connect } from "react-redux";
import { Card, Row } from 'react-bootstrap';
import { PLAN_TYPE_COLOURS, WORK_TYPE_LIST } from "../../../constants";
import WorkedKPI from "./WorkedKPI";
import EGCards from "./EGCards";

const FieldCard = (props) => {
    const { shapeRefId, workTypeId, shapeDetails, selectedPlanTypeId } = props;
    if (!shapeDetails) return <></>;

    let workTypesById = {};
    WORK_TYPE_LIST.forEach(e => {
        if (e.list) {
            e.list.forEach(item => { workTypesById[item.work_type_id] = item; })
        } else workTypesById[e.work_type_id] = e;
    });

    return <Card className="field-item">
        <Row className="header">
            <div className="field-name">{`${shapeDetails.shapeName}`}
                <span className="field-type"
                    style={{
                        color: PLAN_TYPE_COLOURS[selectedPlanTypeId],
                        borderColor: PLAN_TYPE_COLOURS[selectedPlanTypeId]
                    }}>
                    {workTypesById[workTypeId].work_type}
                </span>
            </div>
        </Row>
        <Row className="body">
            <EGCards shapeRefId={shapeRefId} workTypeId={workTypeId} />
            <WorkedKPI shapeRefId={shapeRefId} workTypeId={workTypeId} />
        </Row>
    </Card>
}


const mapStateToProps = (state, ownProps) => {
    const fieldListById = state.farmMonitor.fieldListById.payload;

    return ({
        shapeDetails: fieldListById[ownProps.shapeRefId] ? fieldListById[ownProps.shapeRefId] : null,
        selectedPlanTypeId: state.farmMonitor.selectedPlanTypeId
    });
}

export default connect(mapStateToProps)(FieldCard);